{
  "common": {
    "overviewOverYour": "Übersicht über",
    "lunaGmbh": "Luna Restaurant GmbH",
    "contact": "Kontakt",
    "faq": "FAQ",
    "imprint": "Impressum",
    "privacy": "Datenschutz",
    "notice": "Hinweis:",
    "publicHoliday": "Feiertag",
    "schoolClosed": "Schule geschlossen",
    "schoolHolidays": "Ferien",
    "allergenesAndAdditivesDownloadText": "Allergene, Spuren und Zusatzstoffe für {{month}} als PDF herunterladen",
    "allergenesAndAdditivesSchoolDownloadFileName": "Schul-Speiseplan {{month}} {{year}}.pdf",
    "allergenesAndAdditivesCommonDownloadFileName": "ABC-Speiseplan {{month}} {{year}}.pdf",
    "calendarWeekAbbreviation": "KW",
    "submitting": "Wird gespeichert",
    "emailFailed": "Fehler beim Öffnen des E-Mail-Programms.",
    "emailCopied": "E-Mail-Adresse wurde in die Zwischenablage kopiert.",
    "weekdays": {
      "monday": "Montag",
      "tuesday": "Dienstag",
      "wednesday": "Mittwoch",
      "thursday": "Donnerstag",
      "friday": "Freitag",
      "saturday": "Samstag",
      "sunday": "Sonntag"
    },
    "weekdaysShort": {
      "monday": "Mo",
      "tuesday": "Di",
      "wednesday": "Mi",
      "thursday": "Do",
      "friday": "Fr",
      "saturday": "Sa",
      "sunday": "So"
    },
    "months": {
      "1": "Januar",
      "2": "Februar",
      "3": "März",
      "4": "April",
      "5": "Mai",
      "6": "Juni",
      "7": "Juli",
      "8": "August",
      "9": "September",
      "10": "Oktober",
      "11": "November",
      "12": "Dezember"
    },
    "open": "Öffnen",
    "close": "Schließen",
    "cancel": "Abbrechen",
    "contactBanner": {
      "subtitle": "Sie haben Fragen?",
      "title": "Dann kontaktieren Sie uns.",
      "email": "E-Mail schreiben"
    },
    "amount": "Anzahl",
    "form": {
      "requiredFieldsHint": "Die mit * markierten Bereiche sind erforderlich und müssen bitte ausgefüllt werden.",
      "successBanner": {
        "viewLabel": "Anzeigen",
        "dismissLabel": "Hinweis ausblenden"
      }
    },
    "statusBanner": {
      "error": {
        "forbidden": "Bitte loggen Sie sich neu ein.",
        "generic": "Beim Speichern ist ein Fehler aufgetreten."
      }
    }
  },
  "closeTimes": {
    "title": "Schließzeiten",
    "type": {
      "new": "Neue",
      "current": "Aktuelle"
    },
    "createCloseTime": "Schließzeit anlegen",
    "createCloseTimeText": "Bitte legen Sie Schließzeiten an, wenn die ganze Schule oder ausgewählte Klassen an bestimmten Tagen kein Mittagessen von Luna erhalten sollen.\nDer Grund für die “Schließung” wird den Eltern im Speiseplan angezeigt.",
    "createCloseTimeNotice": "Nachdem Ihre Schließzeit geprüft und freigegeben wurde, wird das Essen für die betroffenen Kinder abbestellt und Sie erhalten eine Bestätigung.",
    "closeTimeOverview": "Schließzeiten Übersicht",
    "closeTimeOverviewText": "In dieser Übersicht sehen Sie die für Ihre Schule eingetragenen Schließzeiten, d.h. Zeiträume, für die durch die Eltern kein Essen bestellt werden kann.\n\nAn gesetzlichen Feiertagen ist ebenfalls keine Essensbestellung möglich. Dies wird systemseitig erfasst und muss nicht von Ihnen gepflegt werden.\n\nBitte beachten Sie: Wird die eingetragene Schließzeit von Ihnen wieder storniert, werden die vorher bereits bestellten Essen der Kinder NICHT wiederhergestellt. Eine Neubestellung durch die Eltern wird notwendig.",
    "successBanner": {
      "createRequestMessage": "Die Schließzeit für den Zeitraum {{dateFrom}} bis {{dateTo}} wurde erfolgreich gespeichert.",
      "editRequestMessage": "Die Schließzeit für den Zeitraum {{dateFrom}} bis {{dateTo}} wurde erfolgreich bearbeitet.",
      "deleteRequestMessage": "Die Schließzeit für den Zeitraum {{dateFrom}} bis {{dateTo}} wurde erfolgreich gelöscht.",
      "cancelRequestMessage": "Die Schließzeit wurde erfolgreich zurückgezogen."
    },
    "form": {
      "editorLabel": "Wer nimmt die Eintragung vor?",
      "editorPlaceholder": "Name des Bearbeiters",
      "closingNoticeLabel": "Was ist der Grund der Schulschließung (Speiseplanhinweis)?",
      "closingNoticePlaceholder": "Anzeigename im Speiseplan",
      "closingNoticeIsNeeded": "Der Speiseplanhinweis wird benötigt.",
      "editorNameIsNeeded": "Der Name des Bearbeiters wird benötigt.",
      "editorNameCannotContainNumbers": "Der Name des Bearbeiters darf keine Zahlen enthalten.",
      "dateLabel": "Welchen Zeitraum soll die Schule geschlossen bleiben?",
      "dateFromPlaceholder": "Datum von",
      "dateFromIsNeeded": "Datum von wird benötigt.",
      "dateFromMustBeAfterToday": "Datum von muss nach dem heutigen Datum liegen.",
      "dateToPlaceholder": "Datum bis",
      "dateToIsNeeded": "Datum bis wird benötigt.",
      "dateToMustBeAfterDateFrom": "Datum bis muss gleich oder nach Datum von liegen.",
      "scopeLabel": "Welcher Bereich ist von der Schließzeit betroffen?",
      "scopePlaceholder": "Bereich wählen",
      "scopeIsNeeded": "Bereich wird benötigt.",
      "classNamePlaceholder": "Klasse wählen",
      "classNameIsNeeded": "Klasse wird benötigt.",
      "resetButtonText": "Eingaben löschen",
      "submitButtonText": "Schließzeit speichern",
      "scopeOptions": {
        "school": "Gesamte Schule",
        "class": "Für Klasse"
      },
      "reviewNotice": "Ihre Eintragung wird von Luna geprüft und freigegeben."
    },
    "table": {
      "header": {
        "from": "Datum von",
        "until": "Datum bis",
        "nameOfCreator": "Name des Bearbeiters",
        "schoolOrClass": "Schule/Klasse",
        "displayNameOnMealPlan": "Anzeigename im Speiseplan",
        "actions": "Aktionen"
      },
      "row": {
        "badges": {
          "createPending": "Eintragung in Prüfung",
          "updatePending": "Bearbeitung in Prüfung",
          "deletePending": "Löschung in Prüfung"
        },
        "actions": {
          "edit": "Bearbeiten",
          "delete": "Löschen",
          "cancel": "Zurückziehen"
        }
      }
    },
    "editModal": {
      "title": "Schließzeit bearbeiten",
      "reviewNotice": "Ihre Bearbeitung wird von Luna geprüft und freigegeben.",
      "cancelButtonText": "Abbrechen",
      "submitButtonText": "Schließzeit ändern"
    },
    "deleteModal": {
      "header": "Schließzeit löschen",
      "title": "Wollen Sie diese Schließzeit wirklich löschen?",
      "description": "Dieser Vorgang kann nicht rückgängig gemacht werden.",
      "reviewNotice": "Ihre Löschung wird von Luna geprüft und freigegeben.",
      "cancelButtonText": "Abbrechen",
      "submitButtonText": "Schließzeit löschen"
    },
    "deleteRequestModal": {
      "cancelButtonText": "Abbrechen",
      "create": {
        "header": "Eintragung zurückziehen",
        "title": "Eintragung zurückziehen",
        "description": "Die Eintragung befindet sich in Prüfung. Wollen Sie die Eintragung wirklich zurückziehen?\nDie Schließzeit wird damit nicht eingetragen.",
        "submitButtonText": "Eintragung zurückziehen"
      },
      "update": {
        "header": "Bearbeitung zurückziehen",
        "title": "Bearbeitung zurückziehen",
        "description": "Die Bearbeitung befindet sich in Prüfung. Wollen Sie die Bearbeitung wirklich zurückziehen?\nDie Schließzeit wird damit in den Zustand vor der Bearbeitung zurückgesetzt. Es erfolgt keine Prüfung.",
        "submitButtonText": "Bearbeitung zurückziehen"
      },
      "delete": {
        "header": "Löschung zurückziehen",
        "title": "Löschung zurückziehen",
        "description": "Die Löschung befindet sich in Prüfung. Wollen Sie die Löschung wirklich zurückziehen?\nDie Schließzeit wird damit nicht gelöscht und bleibt bestehen.",
        "submitButtonText": "Löschung zurückziehen"
      }
    },
    "noSchoolCloseTimes": {
      "text": "Für die gesamte Schule sind keine Schließzeiten hinterlegt."
    },
    "noClassCloseTimes": {
      "text": "Für diese Klasse sind keine Schließzeiten hinterlegt."
    },
    "newCloseTimeButtonText": "Neue Schließzeit anlegen",
    "error": {
      "subtitle": "Schließzeiten",
      "title": "Fehler beim Laden",
      "text": "Schließzeiten konnten nicht geladen werden.",
      "description": "Bitte versuchen Sie es erneut.",
      "retryButtonLabel": "Erneut versuchen"
    }
  },
  "login": {
    "imageHeadline": "HERZLICH WILLKOMMEN",
    "imageSubline": "beim Luna Schulportal",
    "formHeadline": "Login für Schulen",
    "formSubline": "Über unser Schulportal können Sie jetzt ganz einfach und bequem das Schulessen Ihrer Schule bestellen.",
    "emailPlaceholder": "E-Mail",
    "emailIsRequired": "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
    "passwordPlaceholder": "Passwort",
    "passwordIsRequired": "Bitte geben Sie ein Passwort ein.",
    "loginButton": "Im Schulportal anmelden",
    "loginFailed": "Anmeldung fehlgeschlagen. Bitte überprüfen Sie Ihre E-Mail und Passwort.",
    "sessionExpiredTitle": "Sie wurden automatisch abgemeldet.",
    "sessionExpiredMessage": "Bitte melden Sie sich erneut an."
  },
  "header": {
    "mensaApp": "Zur Mensaapp",
    "lunaHome": "Zur Luna Hauptseite",
    "mealPlan": "Speiseplan",
    "closingTimes": "Schließzeiten",
    "guestOrders": "Gastbestellungen",
    "lunchBoxes": "Lunchpakete",
    "currentLists": "Aktuelle Listen",
    "openMenu": "Menü öffnen",
    "closeMenu": "Menü schließen",
    "logout": "Abmelden"
  },
  "titles": {
    "default": "Luna Schulportal",
    "mealPlan": "Speiseplan - Luna Schulportal",
    "closingTimes": "Schließzeiten - Luna Schulportal",
    "guestOrders": "Gastbestellungen - Luna Schulportal",
    "lunchBoxes": "Lunchpakete - Luna Schulportal",
    "currentLists": "Aktuelle Listen - Luna Schulportal",
    "login": "Anmelden - Luna Schulportal"
  },
  "mealPlan": {
    "dateSubtitle": "Ihre Speiseplan Vorschau für",
    "editingDeadlineToday": "Noch **heute** um den Speiseplan für {{month}} zu bearbeiten",
    "editingDeadlineOne": "Noch **{{days}} Tag** um den Speiseplan für {{month}} zu bearbeiten",
    "editingDeadlineOther": "Noch **{{days}} Tage** um den Speiseplan für {{month}} zu bearbeiten",
    "subline": "Haben Sie keinen finalen Speiseplan veröffentlicht, stellen wir im Elternportal die Luna-Empfehlung zur Auswahl.",
    "importantNoticeTitle": "Wichtig",
    "importantNoticeNormalSchool": "Bitte für **alle Tage des gewählten Monats zwei Gerichte** auswählen.",
    "importantNoticeSpecialSchool": "Bitte für alle vegetarischen Tage des gewählten Monats ein Gericht auswählen. An Fleisch- und Fischtagen bitte zwei Gerichte auswählen.",
    "importantNoticeNormalSchoolVegetarian": "Es muss **jeden Tag mindestens ein vegetarisches Gericht** ausgewählt werden.",
    "importantNoticeSpecialSchoolVegetarian": "Es muss **jeden Tag mindestens ein vegetarisches Gericht** ausgewählt werden, auch an Fleisch- und Fischtagen.",
    "meatNotice": "Es darf **pro Kalenderwoche nur 1 Fleischgericht** ausgewählt sein.",
    "fishNotice": "Es muss **pro Kalenderwoche 1 Fischgericht** ausgewählt sein.",
    "changeNotice": "Möchten Sie etwas ändern?",
    "changeActionAddClosingTime": "Schließzeit für {{month}} ergänzen",
    "changeActionAddGuestOrder": "Gastbestellung für {{month}} hinzufügen",
    "changeActionOrderLunchBoxesJuly": "Lunchpakete für {{month}} bestellen",
    "monthSelectionCompleted": "Die Bestellung für {{month}} ist vollständig und wurde erfolgreich an Luna übertragen.",
    "importantNoticeTitleText": "Bitte beachten Sie folgende Hinweise",
    "preselected": "Speiseplan vorausgefüllt – Bitte kontrollieren!",
    "applySuggestions": "Luna-Empfehlungen anwenden",
    "saveTime": "Sparen Sie sich Zeit!",
    "publishChecklistTitle": "Haben Sie an alles gedacht?",
    "publishSelectionSummary": "Sie haben {{count}} Menüs ausgewählt.",
    "publishNotice": "Nachträgliche Änderungen an einem bereits veröffentlichten Speiseplan sind nicht mehr möglich, da direkt nach der Veröffentlichung Bestellungen bei Luna eingehen können.",
    "publishButton": "Speiseplan veröffentlichen",
    "publishSuccessTitle": "Erfolg!",
    "publishSuccessSubtitle": "Vielen Dank für Ihre Auswahl.",
    "publishSuccessDescription": "Ihr Schulspeiseplan wird nun im Elternportal bereitgestellt, sodass ab sofort Essen für {{month}} bestellt werden kann.",
    "publishSuccessCta": "Zum Speiseplan",
    "publishValidationTitle": "Leider ist ein Fehler aufgetreten.",
    "publishValidationSubtitle": "Ihre Menüauswahl ist unvollständig",
    "publishValidationDescription": "Wir haben alle betreffenden Kalendertage markiert. Bitte korrigieren Sie Ihre Auswahl.\n\nSollte Ihre Schule in diesem Monat an einem oder mehreren Tagen geschlossen sein, legen Sie bitte eine Schließzeit an.",
    "publishValidationCta": "Auswahl korrigieren",
    "publishRequestErrorSubtitle": "Ihr Speiseplan konnte nicht veröffentlicht werden.",
    "publishRequestErrorDescription": "Bitte versuchen Sie es erneut. Sollte der Fehler bestehen bleiben, kontaktieren Sie uns.",
    "publishRequestErrorCta": "Erneut versuchen",
    "errorLoadingMenuPlan": "Speiseplan konnte nicht geladen werden.",
    "noData": "Kein Speiseplan für diesen Monat verfügbar.",
    "noDataLinkText": "Zum aktuellen Speiseplan",
    "inPlanning": "In Planung",
    "yearMonthQueryParamKey": "jahr-monat",
    "noticePlanningMonth": "Bestellungen noch nicht möglich.",
    "noticePlanningMonthEmail": "Sie werden per E-Mail informiert."
  },
  "menuCard": {
    "labels": {
      "vegetarian": "Vegetarisch",
      "meat": "Fleisch",
      "fish": "Fisch"
    },
    "dayInvalidReasons": {
      "selectMaxTwoMinOneVegetarian": "Bitte maximal zwei Gerichte auswählen, davon ein vegetarisches Gericht.",
      "selectMaxTwo": "Bitte zwei Gerichte auswählen.",
      "selectExactlyTwoMinOneVegetarian": "Bitte zwei Gerichte auswählen, davon ein vegetarisches Gericht.",
      "selectExactlyTwo": "Bitte zwei Gerichte auswählen.",
      "selectExactlyOne": "Bitte nur ein Gericht auswählen.",
      "minOneVegetarianPerDay": "Es muss täglich ein vegetarisches Gericht ausgewählt sein.",
      "minOneFishPerWeek": "Es muss pro Kalenderwoche ein Fischgericht ausgewählt sein.",
      "maxOneMeatPerWeek": "Es darf pro Kalenderwoche nur ein Fleischgericht ausgewählt sein."
    }
  },
  "desserts": {
    "title": "Dessert"
  },
  "lunchBoxes": {
    "subtitle": "Lecker, gesund und frisch zubereitet",
    "title": "Luna-Lunchpakete",
    "type": {
      "new": "Neues",
      "current": "Aktuelle"
    },
    "deliveryTimes": {
      "REGULAR_DELIVERY": "reguläre Anlieferung",
      "DELIVERY_CUTOFF_07_00": "bis 7.00 Uhr",
      "DELIVERY_CUTOFF_07_30": "bis 7.30 Uhr",
      "DELIVERY_CUTOFF_08_00": "bis 8.00 Uhr",
      "DELIVERY_CUTOFF_08_30": "bis 8.30 Uhr",
      "DELIVERY_CUTOFF_09_00": "bis 9.00 Uhr",
      "DELIVERY_CUTOFF_09_30": "bis 9.30 Uhr",
      "DELIVERY_CUTOFF_10_00": "bis 10.00 Uhr",
      "DELIVERY_CUTOFF_10_30": "bis 10.30 Uhr",
      "DELIVERY_CUTOFF_11_00": "bis 11.00 Uhr"
    },
    "createLunchBox": "Luna-Lunchpaket bestellen",
    "createLunchBoxText": "Unsere Luna-Lunchpakete sind lecker, gesund und werden kurz vor der Lieferung ganz **frisch von uns zubereitet**. Sie als Schulpersonal wählen aus unseren **Lunchpaketen** das Lieblingsangebot Ihrer Schüler aus, um den Kindern eine ausgewogene Verpflegung für den Tag zu gewährleisten, zum Beispiel für **ganztägige Ausflüge** wie Wandertage oder Projekttage.",
    "lunchBoxOverview": "Luna-Lunchpakete Übersicht",
    "lunchBoxOverviewText": "In dieser Übersicht sehen Sie alle Lunchpaket-Bestellungen. Sie haben hier die Möglichkeit, Bestellungen zu **stornieren**, sollten diese doch nicht gebraucht werden. Dies ist nur **innerhalb einer Frist von 2 Werktagen vor dem Lieferdatum** möglich.",
    "table": {
      "header": {
        "deliveryDate": "Lieferdatum",
        "deliveryTime": "Uhrzeit",
        "quantity": "Stückzahl",
        "lunchPaketName": "Lunchpaket",
        "schoolClass": "Klasse",
        "address": "Lieferanschrift",
        "nameOfCreator": "Name des Bearbeiters",
        "comment": "Kommentar",
        "actions": "Aktionen"
      },
      "row": {
        "actions": {
          "delete": "Stornieren",
          "cancelled": "Storniert"
        }
      }
    },
    "cancelModal": {
      "header": "Lunchpakete stornieren",
      "title": "Wollen Sie die Lunchpakete wirklich stornieren?",
      "tableHeaderText": "Ihre Bestellung:",
      "notice": "Die Lunchpaket-Bestellung kann storniert werden. Dies ist nur **innerhalb einer Frist von 2 Werktagen vor dem Lieferdatum** möglich.",
      "cancelButtonText": "Abbrechen",
      "submitButtonText": "Lunchpakete stornieren"
    },
    "cancelValidation": {
      "leadTimeNotMet": "Zwischen Stornierung und Lieferdatum müssen mindestens {{minBusinessDays}} Werktage liegen. Stornierungen nach 13:00 Uhr gelten erst am nächsten Werktag."
    },
    "noLunchBoxes": {
      "text": "Es sind derzeit keine Lunchpakete bestellt."
    },
    "error": {
      "subtitle": "Lunchpakete",
      "title": "Fehler beim Laden",
      "text": "Lunchpakete konnten nicht geladen werden.",
      "description": "Bitte versuchen Sie es erneut.",
      "retryButtonLabel": "Erneut versuchen"
    },
    "newLunchBoxButtonText": "Neues Lunchpaket bestellen",
    "createLunchBoxNotice": "**Vertragsbedingungen für die Bestellung von Lunchpaketen:**\n\nErfolgt die Bestellung mindestens 5 Werktage (Montag bis Freitag) vor Auslieferung der Lunchpakete, kann das Lunchpaket ausgewählt werden. Erfolgt die Bestellung mindestens 2 Werktage vor Auslieferung, wird das Lunapaket geliefert.\n\nBestellungen, die später als zwei Werktage vor Auslieferung während der Geschäftszeiten bei Luna eingehen, können leider nicht mehr berücksichtigt werden. \n\nDie Geschäftszeiten sind von 8.00 bis 13.00 Uhr. Bei der Bestellung handelt es sich um einen verbindlichen Auftrag.",
    "form": {
      "addressLabel": "Für welche Klasse möchten Sie Lunchpakete bestellen?",
      "addressPlaceholder": "Lieferanschrift",
      "addressIsNeeded": "Die Lieferanschrift wird benötigt.",
      "classNameAllOption": "Alle",
      "classNamePlaceholder": "Klasse oder Gruppe wählen",
      "classNameIsNeeded": "Klasse oder Gruppe wird benötigt.",
      "classNameOrGroupCustomOption": "Andere Gruppe",
      "classNameOrGroupCustomNamePlaceholder": "Namen der Gruppe eingeben",
      "classNameOrGroupCustomCreate": "Gruppe anlegen",
      "classNameOrGroupCustomNameIsNeeded": "Der Name der Gruppe wird benötigt.",
      "classNameOrGroupCustomCreateFailed": "Die Gruppe konnte nicht erstellt werden.",
      "classNameOrGroupCustomAlreadyExists": "Eine Gruppe mit diesem Namen existiert bereits.",
      "classNameOrGroupCustomMustBeCreated": "Bitte legen Sie zuerst eine Gruppe an.",
      "editorLabel": "Wer nimmt die Bestellung vor?",
      "editorPlaceholder": "Name des Bearbeiters",
      "editorNameIsNeeded": "Der Name des Bearbeiters wird benötigt.",
      "editorNameCannotContainNumbers": "Der Name des Bearbeiters darf keine Zahlen enthalten.",
      "amountLabel": "Wie viele Lunchpakete werden benötigt?",
      "amountPlaceholder": "Stückzahl eingeben",
      "amountIsNeeded": "Die Stückzahl wird benötigt.",
      "amountMustBeNumeric": "Die Stückzahl muss eine Zahl sein.",
      "amountLessThanPeopleWithAllergies": "Die Stückzahl darf nicht kleiner sein als die Anzahl der angegebenen Personen mit Allergien.",
      "peopleWithAllergiesLabel": "Bitte ergänzen Sie die Namen der Allergiker.",
      "peopleWithAllergiesDescription": "Diese sind in der angegebenen Stückzahl bereits enthalten.",
      "peopleWithAllergiesNamePlaceholder": "Vorname Nachname",
      "peopleWithAllergiesNameIsNeeded": "Bitte geben Sie den Namen des Allergiker-Kindes ein.",
      "peopleWithAllergiesNameTooLong": "Der Name des Allergiker-Kindes darf höchstens {{maxLength}} Zeichen enthalten.",
      "peopleWithAllergiesNameAddButton": "Weitere Allergiker hinzufügen",
      "peopleWithAllergiesNameRemoveButton": "Entfernen",
      "dateLabel": "Wann werden die Lunchpakete benötigt?",
      "datePlaceholder": "Lieferdatum",
      "dateIsNeeded": "Lieferdatum wird benötigt.",
      "dateWeekendNotAllowed": "Lieferungen sind nur von Montag bis Freitag möglich. Bitte wählen Sie einen Werktag.",
      "dateLeadTimeNotMet": "Zwischen Bestellung und Lieferdatum müssen mindestens {{minBusinessDays}} Werktage liegen. Bestellungen nach 13:00 Uhr gehen erst am nächsten Werktag ein.",
      "timePlaceholder": "Uhrzeit wählen",
      "timeIsNeeded": "Uhrzeit wird benötigt.",
      "lunchBoxLabel": "Welches Lunchpaket wird gewünscht?",
      "lunchBoxPlaceholder": "Lunchpaket wählen",
      "lunchBoxIsNeeded": "Lunchpaket wird benötigt.",
      "commentLabel": "Kommentar",
      "commentPlaceholder": "Kommentar eingeben",
      "commentDescription": "z. B. welche Schüler der gewählten Klasse kein Lunchpaket erhalten sollen",
      "createLunchBox": "Luna-Lunchpakete verbindlich bestellen",
      "resetButton": "Eingaben löschen",
      "successBanner": {
        "message": "Die Lunchpaket-Bestellung für den {{date}} wurde erfolgreich gespeichert"
      }
    }
  },
  "guestOrders": {
    "type": {
      "new": "Neues",
      "current": "Aktuelle"
    },
    "form": {
      "dateLabel": "Für welchen Zeitraum möchten Sie Gastessen bestellen?",
      "dateFromPlaceholder": "Datum von",
      "dateFromIsNeeded": "Datum von wird benötigt.",
      "dateToPlaceholder": "Datum bis",
      "dateToIsNeeded": "Datum bis wird benötigt.",
      "dateToMustBeAfterDateFrom": "Enddatum muss gleich oder nach Startdatum liegen.",
      "datePlaceholder": "Datum",
      "dateIsNeeded": "Datum wird benötigt.",
      "editorLabel": "Wer nimmt diese Bestellung vor?",
      "editorPlaceholder": "Name des Bearbeiters",
      "editorNameIsNeeded": "Der Name des Bearbeiters wird benötigt.",
      "editorNameCannotContainNumbers": "Der Name des Bearbeiters darf keine Zahlen enthalten.",
      "editorNameTooLong": "Der Name darf maximal 255 Zeichen lang sein.",
      "commentTooLong": "Der Kommentar darf maximal 1000 Zeichen lang sein.",
      "commentLabel": "Haben Sie weitere Anmerkungen für uns?",
      "commentPlaceholder": "Kommentar hinzufügen",
      "chooseDishes": "Gerichte auswählen",
      "orderGuestOrders": "Gastessen verbindlich bestellen",
      "pleaseChooseDishes": "Bitte die Gerichte auswählen:",
      "resetButton": "Eingaben löschen",
      "amountIsNeeded": "Die Anzahl wird benötigt.",
      "noSchoolAssigned": "Es ist keine Schule zugeordnet.",
      "noPositionsSelected": "Bitte wählen Sie mindestens ein Gericht aus.",
      "everyDayNeedsSelection": "Bitte wählen Sie für jeden Tag mindestens ein Gericht aus.",
      "datesNoLongerOrderable": "Die Bestellfrist für alle ausgewählten Tage ist bereits abgelaufen.",
      "someDatesSkipped": "Hinweis: Für folgende Tage ist die Bestellfrist abgelaufen und sie wurden übersprungen: {{dates}}",
      "successBanner": {
        "message": "Die Gastbestellung für den Zeitraum {{dateFrom}} bis {{dateTo}} wurde erfolgreich gespeichert"
      }
    },
    "noMealPlanNotice": "Leider liegt für Ihren gewünschten Zeitraum kein Speiseplan vor.",
    "noMealPlanForDatesNotice": "Für den Zeitraum {{dateFrom}} bis {{dateTo}} können Sie leider keine Gastbestellung aufgeben.",
    "noMealPlanForSingleDateNotice": "Für den {{date}} können Sie leider keine Gastbestellung aufgeben.",
    "subtitle": "Für spontane Extra-Menüs",
    "title": "Gastbestellungen",
    "createGuestOrder": "Gastessen bestellen",
    "createGuestOrderText": "Nutzen Sie diese Option\n\n- wenn Sie Kinder aus anderen Berliner Grundschulen als **Gastesser** betreuen und für sie Mittagessen bestellen möchten.\n- außerdem können Sie hier Mittagessen für **zukünftige Erstklässler** bestellen, deren Eltern **noch keinen Vertrag mit Luna** abgeschlossen haben.\n\nDas bedeutet: Diese Option ist **nicht** für regulär angemeldete Schüler gedacht, sondern nur für Gastkinder oder zukünftige Erstklässler, die noch nicht im Luna-System registriert sind.",
    "createGuestOrderNotice": "Gastbestellungen können bis 12:00 Uhr am Vortag aufgegeben, geändert oder storniert werden. Dies bedeutet: Bestellungen für morgen sind heute bis 12:00 Uhr möglich.",
    "guestOrdersOverview": "Gastbestellungen Übersicht",
    "guestOrdersOverviewText": "In dieser Übersicht sehen Sie alle Gastbestellungen. Das **Bearbeiten** und **Stornieren** von Gastbestellungen ist für jeden **einzelnen Tag** möglich, für den Sie bestellt haben.",
    "table": {
      "header": {
        "date": "Datum",
        "totalMeals": "Essen gesamt",
        "nameOfCreator": "Name des Bearbeiters",
        "comment": "Kommentar",
        "actions": "Aktionen"
      },
      "row": {
        "actions": {
          "edit": "Bearbeiten",
          "cancel": "Stornieren",
          "cancelled": "Storniert"
        }
      }
    },
    "noGuestOrders": {
      "text": "Es sind derzeit keine Gastessen bestellt."
    },
    "newGuestOrderButtonText": "Neues Gastessen bestellen",
    "editModal": {
      "title": "Gastbestellung bearbeiten",
      "notice": "Beachten Sie bitte bei Änderungen die aktuell geltenden Bestellfristen!",
      "cancelButtonText": "Abbrechen",
      "submitButtonText": "Gastessen Änderung versenden",
      "successMessage": "Die Gastbestellung wurde erfolgreich aktualisiert",
      "deadlinePassed": "Die Bestellfrist für diesen Tag ist abgelaufen. Änderungen sind nicht mehr möglich."
    },
    "cancelModal": {
      "header": "Gastbestellungen stornieren",
      "title": "Wollen Sie die Gastbestellungen wirklich stornieren?",
      "tableHeaderText": "Ihre Bestellung:",
      "notice": "Gastbestellungen können bis 12:00 Uhr am Vortag storniert werden.",
      "cancelButtonText": "Abbrechen",
      "submitButtonText": "Gastbestellungen stornieren"
    },
    "cancelValidation": {
      "alreadyCancelled": "Diese Gastbestellung wurde bereits storniert.",
      "deadlinePassed": "Die Bestellfrist für diesen Tag ist abgelaufen. Stornierungen sind nicht mehr möglich."
    }
  },
  "currentLists": {
    "title": "Downloadbereich",
    "subtitle": "Aktuelle Listen",
    "leftContainerHeadline": {
      "title": "Teilnehmerliste",
      "subtitle": "Hier finden Sie eine **tagesaktuelle** Übersicht der Essensteilnehmer Ihrer Schule als PDF-Datei zum Download.",
      "buttonText": "Teilnehmerliste herunterladen",
      "fileName": "Teilnehmerliste {{date}}.pdf"
    },
    "rightContainerHeadline": {
      "title": "BE-Liste",
      "subtitle": "Hier finden Sie die monatliche Liste für Ihre Diabetiker.",
      "buttonText": "BE-Liste herunterladen",
      "fileName": "BE-Liste {{date}}.pdf"
    }
  }
}
